var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-main-content",
      attrs: {
        "element-loading-text": "",
        "element-loading-spinner": "none",
        "element-loading-background": "rgba(170,170,170,0)"
      }
    },
    [
      _c("customer-share-tree-grid", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.view === "list",
            expression: "view==='list'"
          }
        ],
        ref: "customerShareTreeGrid",
        staticStyle: { flex: "1" },
        attrs: { "model-type": 2, "show-source-type": false, no: "1" },
        on: { look: _vm.lookHandle }
      }),
      _c("customer-workspace", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.view === "detail",
            expression: "view==='detail'"
          }
        ],
        ref: "customerWorkspace",
        attrs: { "model-type": 2, "show-source-type": false, no: "2" },
        on: { back: _vm.backToList }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }